import { createAction, props, union } from '@ngrx/store';

export const setDismissed = createAction('[MilestoneActions] setDismissed', props<{ points: number }>());

const _all = union({ setDismissed });
export type MilestonesActionsUnion = typeof _all;
